import MainPage from "../../components/lesson/mainPage";

const Levels = ({ authUser }) => {
  return (
    <>
      <MainPage authUser={authUser} />
    </>
  );
};
export default Levels;
